import { Box, SystemIcon, Typography } from '@wishket/design-system';

import { FadeUpContainer } from '@/shared/Components';

interface AskAIQuestionCardProps {
  text: string;
}

const AskAIQuestionCard = ({ text }: AskAIQuestionCardProps) => {
  return (
    <FadeUpContainer>
      <Box className="flex items-center gap-5 rounded-3xl bg-primary-10 p-5 desktop:gap-6 desktop:p-6">
        <Box className="flex size-8 shrink-0 items-center justify-center rounded-full bg-w-white desktop:size-10">
          <SystemIcon
            name="large_question"
            className="hidden text-primary desktop:block"
          />
          <SystemIcon
            name="medium_question"
            className="text-primary desktop:hidden"
          />
        </Box>
        <Typography variant="contents2" className="text-w-gray-800">
          {text}
        </Typography>
      </Box>
    </FadeUpContainer>
  );
};

export default AskAIQuestionCard;
